import React, { useRef, useState } from "react";

export default function BeforeAfter({ before, after, beforeAlt = "Before", afterAlt = "After" }) {
  const [pct, setPct] = useState(50);
  const ref = useRef(null);

  const onMove = (clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const p = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
    setPct(p);
  };

  return (
    <div
      ref={ref}
      className="ba-wrap aspect-[16/10] bg-paper"
      onMouseMove={(e) => e.buttons === 1 && onMove(e.clientX)}
      onTouchMove={(e) => onMove(e.touches[0].clientX)}
      onClick={(e) => onMove(e.clientX)}
      data-testid="before-after-slider"
    >
      <img src={before} alt={beforeAlt} loading="lazy" className="absolute inset-0 w-full h-full object-cover select-none" />
      <div className="ba-after" style={{ clipPath: `inset(0 0 0 ${pct}%)` }}>
        <img src={after} alt={afterAlt} loading="lazy" className="absolute inset-0 w-full h-full object-cover select-none" />
      </div>
      <div className="ba-handle" style={{ left: `${pct}%` }} />
      <div className="absolute top-3 left-3 pill bg-white/85 text-dark border-0">Before</div>
      <div className="absolute top-3 right-3 pill bg-dark text-lime border-0">After</div>
    </div>
  );
}
